<template>
  <section class="app-main padding-container">
    <FixedBar :button="['back']"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </section>
</template>

<script>
import lang from '@/options/lang'
import FixedBar from '@/components/public/FixedBar'
export default {
  name: 'AppMain',
  components: {
    FixedBar
  },
  computed: {
    
  }
}
</script>

<style>
.app-main {
  min-height: calc(100vh);
  position: relative;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  border-left:1px solid #e6e6e6;
}
.padding-container {
  padding:20px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue